import { retrieveData, removeData, storeData } from './storageHelper';

export const getToken = () => {
  return retrieveData('token');
};

export const setToken = (token) => {
  storeData('token', token);
};

export const clearToken = () => {
  removeData('token');
  return true;
};
